import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 md:py-20 bg-white px-5 border-b border-gray-100" data-id="element-87">
      <div className="max-w-3xl mx-auto text-center" data-id="element-88">
        <div className="inline-block bg-emerald-50 p-6 rounded-full mb-6" data-id="element-89">
          <ShieldCheck className="w-16 h-16 text-emerald-600" strokeWidth={1.5} data-id="element-90" />
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-91">
          🛡️ Garantía sin riesgo de 7 días
        </h2>

        <p className="text-lg md:text-xl text-gray-600 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-92">
          Probalo durante una semana completa. Si no sentís que este manual es
          lo que necesitás para tu etapa, te devolvemos el 100% del dinero.
        </p>

        <p className="text-base font-bold text-emerald-800 bg-emerald-50 inline-block px-6 py-2.5 rounded-full border border-emerald-100" data-id="element-93">
          Sin preguntas. Sin letra chica.
        </p>
      </div>
    </section>;
}